import { NgModule } from '@angular/core';

import { MonitorCoreModule } from './Core/monitor-core.module';
import { BriefingsModule } from './Briefings/briefings.module';
import { AlertsModule } from './Alerts/alerts.module';
import { MediaSubscriptionsModule } from './MediaSubscriptions/media-subscriptions.module';
import { ReportsModule } from '../Common/Reports/reports.module';
import { MonitoringRoutingModule } from './MonitoringRouter/monitoring-routing.module';
import { MonitoringComponent } from './Core/components/Monitoring/monitoring.component';


@NgModule({
    imports: [
        MonitorCoreModule,
        BriefingsModule,
        AlertsModule,
        MediaSubscriptionsModule,
        ReportsModule,
        MonitoringRoutingModule
    ],
    exports: [
        MonitoringComponent
    ]
})
export class MonitorModule { }
